// Admin console translations — kept separate to keep translations.js lean.
export const ADMIN_I18N = {
  en: {
    console: "admin console",
    title: "Kuryarti Studio",
    welcome: (name) => `Welcome back, ${name}. Here is what the studio looks like today.`,
    refresh: "Refresh",
    tabs: { overview: "Overview", requests: "Requests", clients: "Clients", inbox: "Inbox", content: "Content" },
    kpi: {
      total_requests: "Total Requests",
      pending: "Pending Review",
      in_progress: "In Progress",
      awaiting_payment: "Awaiting Payment",
      completed: "Completed",
      total_clients: "Clients",
    },
    loading: "Loading…",
    recent: "recent requests",
    view_all: "View all →",
    no_requests: "No requests yet.",
    top_clients: "top clients",
    no_clients: "No clients yet.",
    status: "status",
    view_brief: "View brief",
    hide_brief: "Hide brief",
    payment: {
      amount: "Amount (USD)",
      portion: "Portion",
      deposit: "Deposit — 50% at start",
      balance: "Balance — 50% at delivery",
      full: "Full payment — 100%",
      issue: "Issue payment order",
      payment_lbl: "payment",
      link_lbl: "Payment link (Payoneer)",
    },
    filters: {
      all: "all", pending: "pending", approved: "approved",
      in_progress: "in progress", completed: "completed", rejected: "rejected",
    },
    no_matching: "No matching requests.",
    select_request: "Select a request.",
    clients_cols: ["Client", "Email", "Provider", "Requests", "Last project", "Joined"],
    inbox_empty: "Inbox empty.",
    reply: "Reply",
    revert_status: {
      approved: "approved", in_progress: "in progress", rejected: "rejected", completed: "completed",
    },
  },

  ru: {
    console: "админ панель",
    title: "Kuryarti Студия",
    welcome: (name) => `С возвращением, ${name}. Вот как выглядит студия сегодня.`,
    refresh: "Обновить",
    tabs: { overview: "Обзор", requests: "Заявки", clients: "Клиенты", inbox: "Входящие", content: "Контент" },
    kpi: {
      total_requests: "Всего заявок",
      pending: "На рассмотрении",
      in_progress: "В работе",
      awaiting_payment: "Ожидает оплату",
      completed: "Завершено",
      total_clients: "Клиенты",
    },
    loading: "Загрузка…",
    recent: "недавние заявки",
    view_all: "Все →",
    no_requests: "Заявок пока нет.",
    top_clients: "топ клиенты",
    no_clients: "Клиентов пока нет.",
    status: "статус",
    view_brief: "Показать бриф",
    hide_brief: "Скрыть бриф",
    payment: {
      amount: "Сумма (USD)",
      portion: "Часть",
      deposit: "Депозит — 50% при старте",
      balance: "Остаток — 50% при сдаче",
      full: "Полная оплата — 100%",
      issue: "Выставить счёт",
      payment_lbl: "оплата",
      link_lbl: "Ссылка на оплату (Payoneer)",
    },
    filters: {
      all: "все", pending: "новые", approved: "одобрено",
      in_progress: "в работе", completed: "готово", rejected: "отклонено",
    },
    no_matching: "Нет подходящих заявок.",
    select_request: "Выберите заявку.",
    clients_cols: ["Клиент", "Email", "Провайдер", "Заявок", "Последний проект", "Регистрация"],
    inbox_empty: "Входящие пусты.",
    reply: "Ответить",
    revert_status: {
      approved: "одобрить", in_progress: "в работу", rejected: "отклонить", completed: "завершить",
    },
  },

  es: {
    console: "consola de admin",
    title: "Estudio Kuryarti",
    welcome: (name) => `Bienvenida, ${name}. Así se ve el estudio hoy.`,
    refresh: "Actualizar",
    tabs: { overview: "Resumen", requests: "Solicitudes", clients: "Clientes", inbox: "Bandeja", content: "Contenido" },
    kpi: {
      total_requests: "Total Solicitudes",
      pending: "Por Revisar",
      in_progress: "En Curso",
      awaiting_payment: "Esperando Pago",
      completed: "Completadas",
      total_clients: "Clientes",
    },
    loading: "Cargando…",
    recent: "solicitudes recientes",
    view_all: "Ver todas →",
    no_requests: "Aún no hay solicitudes.",
    top_clients: "top clientes",
    no_clients: "Aún no hay clientes.",
    status: "estado",
    view_brief: "Ver brief",
    hide_brief: "Ocultar brief",
    payment: {
      amount: "Monto (USD)",
      portion: "Parte",
      deposit: "Depósito — 50% al iniciar",
      balance: "Saldo final — 50% al entregar",
      full: "Pago único — 100%",
      issue: "Emitir orden de cobro",
      payment_lbl: "pago",
      link_lbl: "Link de pago (Payoneer)",
    },
    filters: {
      all: "todas", pending: "nuevas", approved: "aprobadas",
      in_progress: "en curso", completed: "completadas", rejected: "rechazadas",
    },
    no_matching: "No hay solicitudes con ese filtro.",
    select_request: "Selecciona una solicitud.",
    clients_cols: ["Cliente", "Email", "Proveedor", "Solicitudes", "Último proyecto", "Registro"],
    inbox_empty: "Bandeja vacía.",
    reply: "Responder",
    revert_status: {
      approved: "aprobar", in_progress: "en curso", rejected: "rechazar", completed: "completar",
    },
  },
};
